__turbopack_context__.v({
  "arrow": "ParagraphAnnouncementBar-module__fA-FXa__arrow",
  "icon": "ParagraphAnnouncementBar-module__fA-FXa__icon",
  "inner": "ParagraphAnnouncementBar-module__fA-FXa__inner",
  "pagination": "ParagraphAnnouncementBar-module__fA-FXa__pagination",
  "pill": "ParagraphAnnouncementBar-module__fA-FXa__pill",
  "progressFill": "ParagraphAnnouncementBar-module__fA-FXa__progressFill",
  "progressRing": "ParagraphAnnouncementBar-module__fA-FXa__progressRing",
  "progressRingFill": "ParagraphAnnouncementBar-module__fA-FXa__progressRingFill",
  "progressTrack": "ParagraphAnnouncementBar-module__fA-FXa__progressTrack",
  "root": "ParagraphAnnouncementBar-module__fA-FXa__root",
  "slide": "ParagraphAnnouncementBar-module__fA-FXa__slide",
  "slideLink": "ParagraphAnnouncementBar-module__fA-FXa__slideLink",
  "swiper": "ParagraphAnnouncementBar-module__fA-FXa__swiper",
  "swiperWrap": "ParagraphAnnouncementBar-module__fA-FXa__swiperWrap",
  "text": "ParagraphAnnouncementBar-module__fA-FXa__text",
});
